import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { PacoteReserva } from "src/app/model";
import { LoginService, PacotelstService, UsuarioService, Util } from "src/app/services";
import { ModalComponent } from "../../modal/modal.component";

@Component({
  selector: "app-pacote-card",
  standalone: false,
  templateUrl: "./pacote-card.component.html",
  styleUrl: "./pacote-card.component.scss",
})
export class PacoteCardComponent implements OnInit {
  @Input() pacoteReserva: PacoteReserva;
  @Input() statusOrcamento: number;
  @Input() liberarVoucher: boolean;
  @Input() termometroValido: boolean = false;
  @Input() cardSimplificado: boolean = false;
  @Input() pacoteReservaId: number = null;
  @Input() idadeInvalida: boolean = false;
  @Input() cardItem: any;

  @Output() verificaIdadeValida: EventEmitter<void> = new EventEmitter<void>();
  @Output() carregarObjetoEmitter: EventEmitter<number> = new EventEmitter();
  @Output() imprimirVoucherEmitter: EventEmitter<PacoteReserva> = new EventEmitter();
  @Output() atualizarPacoteEmitter: EventEmitter<number> = new EventEmitter();

  @ViewChild("modalReserva") modalReserva: ModalComponent;
  @ViewChild("modalCancela") modalCancela: ModalComponent;

  expandedDetails: boolean = false;
  mensagensSucessoPacote: string = "";
  mensagemErroPacote: string = "";
  empresaId: any;

  constructor(private pacoteService: PacotelstService, private utilService: Util, private usuarioService: LoginService) {}

  ngOnInit(): void {
    if (this.cardSimplificado) {
      if (this.cardItem != null && this.cardItem != undefined) {
        this.pacoteReserva = this.cardItem;
      } else if (this.pacoteReservaId) {
        this.buscaPacoteReservaPorId();
      }
    } else if (this.pacoteReservaId) {
      this.buscaPacoteReservaPorId();
    }

    this.empresaId = this.usuarioService.pegaUsuario().EmpresaId;
  }

  removerPacoteReserva() {
    if (this.termometroValido) {
      alert(this.utilService.fazerTraducao("Necessário retornar o valor do termômetro para padrão antes de remover esse item."));
      return;
    }

    this.pacoteService.removerPacoteReservaEstatico(this.pacoteReserva.Id).subscribe(
      (dados) => {
        this.mensagensSucessoPacote = "Pacote Removido com Sucesso!";
        this.atualizarPacoteEmitter.emit(this.pacoteReserva.Id);
        this.carregarObjetoEmitter.emit(this.pacoteReserva.ReservaId);
      },
      (erro) => {
        this.mensagemErroPacote = this.utilService.errorHandler(erro);
      }
    );
  }

  buscaPacoteReservaPorId() {
    this.pacoteService.buscarPacoteReservaPorId(this.pacoteReservaId).subscribe(
      (dados) => {
        this.pacoteReserva = dados;
      },
      (erro) => {
        this.mensagemErroPacote = this.utilService.errorHandler(erro);
      }
    );
  }

  validaSePodeReservar() {
    this.verificaIdadeValida.emit();
    if (this.idadeInvalida) {
      this.mensagemErroPacote = this.utilService.fazerTraducao("Verifique a Idade dos passageiros.");
      return;
    } else {
      this.modalReserva.open();
    }
  }

  atualizarPacoteReserva(pacoteAtualizado: any) {
    // Atualiza o objeto local com os dados retornados da reserva
    Object.assign(this.pacoteReserva, pacoteAtualizado);
    // Emite o evento para recarregar o objeto completo
    this.carregarObjetoEmitter.emit(this.pacoteReserva.ReservaId);
  }
}
